import { useCallback } from 'react';
import { useToast } from '@shared/components/Toast';
import { useBusinessRole } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { useNavigateToRoute } from '@shared/util/navigation';

export function useUpgrade(): () => void {
  const toast = useToast();
  const { isBusinessAdmin } = useBusinessRole();
  const navigateToBilling = useNavigateToRoute('Billing');
  return useCallback(() => {
    if (!isBusinessAdmin) {
      toast({
        style: 'important',
        message: i18n('billing.metricsCounter.contactAdminPrompt'),
      });
    } else {
      navigateToBilling();
    }
  }, [toast, isBusinessAdmin, navigateToBilling]);
}
